<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="hostel" slot-scope="hostel">
          <div class="text-wrap">{{hostel}}</div>
        </template>
        <template slot="student" slot-scope="student">
          <div>
            <div class="font-weight-bold text-wrap">{{ student }}</div>
          </div>
        </template>
        <template slot="remark" slot-scope="remark">
          <div>
            <div class="text-wrap">{{ remark }}</div>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>

          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  { title: 'Hostel', width: 100, dataIndex: 'hostel', scopedSlots: { customRender: 'hostel' } },
  { title: 'Student', width: 100, dataIndex: 'student', scopedSlots: { customRender: 'student' } },
  { title: 'Transaction ID', width: 200, className: 'text-center', dataIndex: 'transaction_id', scopedSlots: { customRender: 'transaction_id' } },
  { title: 'Amount', width: 100, className: 'text-center', dataIndex: 'amount', scopedSlots: { customRender: 'amount' } },
  { title: 'Bal. Amt.', width: 130, className: 'text-center', dataIndex: 'balance_amount', scopedSlots: { customRender: 'balance_amount' } },
  { title: 'D/T', width: 130, className: 'text-center', dataIndex: 'transaction_date_time', scopedSlots: { customRender: 'transaction_date_time' } },
  { title: 'Type', width: 130, className: 'text-center', dataIndex: 'type', scopedSlots: { customRender: 'type' } },
  { title: 'Remark', width: 100, className: 'text-center', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'hostelPocketMoneyTable',
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this pocket money transaction?',
        content: `You are about to delete ${record.student} pocket money.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/hostel/pocket-money/single/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.student + ` pocket money has been deleted.`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
